<template>
    <form
        class="subscribe"
        @submit.prevent="subscribe"
    >
        <template v-if="status === 'success'">
            <Txt size="xs" heading>
                Subscribe to our newsletter
            </Txt>
            <Txt size="s">
                Thanks for subscribing, you will never miss a story.
            </Txt>
        </template>
        <template v-else>
            <Field
                v-model:value="email"
                type="email"
                placeholder="Enter your email"
                show-info-always
            >
                <Txt size="xs" heading>
                    Subscribe to our newsletter
                </Txt>
            </Field>
            <Button
                type="submit"
                variant="create"
                size="xs" heading
                :status="status"
                fill
            >
                Subscribe
            </Button>
        </template>
    </form>
</template>

<script>
import Txt from '@/components/form/txt';
import Field from '@/components/form/field';
import Button from '@/components/utility/button';

export default {
    name: 'SubscribeForm',
    components: { Txt, Field, Button },
    data() {
        return {
            email: '',
            status: null
        };
    },
    methods: {
        subscribe() {
            this.status = 'waiting';
            return this.$http.post('/feedback/subscribe', { email: this.email })
                .then(() => {
                    this.status = 'success';
                    this.$track.event('Newsletter Subscribed', {
                        'email': this.email,
                        'contact_list': 'newsletter'
                    });
                });
        }
    }
};
</script>

<style lang="less">
.subscribe {
    width: 100%;
    margin-top: 16px;
    padding: 40px 0;
    border-top: 1px solid var(--steel);
    .txt-component.heading { color: var(--navy); }
    > .txt-component.heading {
        margin-bottom: 12px;
    }
    .field .field-container {
        border-radius: 24px;
    }
    .cobutton {
        padding: 14px;
        .txt-component.heading { color: #FFF; }
    }
}
</style>
